import React from "react";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { Button, Grid, Typography } from "@material-ui/core";
import useStyles from "./Login.styles";
import Input from "../../components/form-fields/Input";
import FlokkButton from "../../components/FlokkButton";
import { login, setOriginalPath } from "../../redux/user/user.actions";
import { forgotPassword as forgotPasswordRemote } from "../../helpers/services/UserServices";
import { useTranslation } from "react-i18next";

const Login = ({ login, location, user, errors }) => {
  const styles = useStyles();
  const { t } = useTranslation();
  const [showLogin, setShowLogin] = React.useState(true);
  const [showPasswordForgotForm, setShowPasswordForgotForm] =
    React.useState(false);
  const [displayMessage, setDisplayMessage] = React.useState("");
  const [passwordForgotFormSubmitted, setPasswordForgotFormSubmitted] =
    React.useState(false);
  const switchToForgotPassword = () => {
    setPasswordForgotFormSubmitted(false);
    setDisplayMessage("");
    setShowPasswordForgotForm(true);
    setShowLogin(false);
  };

  const switchToLogin = () => {
    setShowPasswordForgotForm(false);
    setShowLogin(true);
  };

  const forgotPassword = async (data) => {
    try {
      await forgotPasswordRemote(data.email);
      setPasswordForgotFormSubmitted(true);
      setDisplayMessage(t("system.forgotPassword_heading"));
    } catch (error) {}
  };
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={styles.container}
    >
      {showLogin && (
        <Grid item xs={10} sm={6} md={6} lg={4} xl={3}>
          <Formik
            initialValues={{ email: "", password: "" }}
            onSubmit={(data, { setSubmitting, resetForm }) => {
              setSubmitting(true);
              login(data);
              setSubmitting(false);
              //resetForm();
            }}
          >
            {({ values, isSubmitting }) => (
              <Form>
                <Input name="email" type="input" label="E-Mail" />

                <Input name="password" type="password" label="Passwort" />

                <FlokkButton
                  className={styles.button}
                  color="primary"
                  variant="contained"
                  fullWidth
                  type="submit"
                  disabled={isSubmitting}
                >
                  {t("system.login_btn")}
                </FlokkButton>
              </Form>
            )}
          </Formik>
          <Typography
            className={styles.forgotPasswordLink}
            align="center"
            onClick={switchToForgotPassword}
          >
            {t("system.forgotPassword_link")}
          </Typography>
          <div className={styles.errorMessage}>
            {errors && errors.info && getErrorMessage(errors.info.error, t)}
          </div>
        </Grid>
      )}

      {showPasswordForgotForm && (
        <Grid item xs={10} sm={6} md={6} lg={4} xl={3}>
          {!passwordForgotFormSubmitted && (
            <Formik
              initialValues={{ email: "" }}
              onSubmit={(data, { setSubmitting, resetForm }) => {
                setSubmitting(true);
                forgotPassword(data);
                setSubmitting(false);
                //resetForm();
              }}
            >
              {({ values, isSubmitting }) => (
                <Form>
                  <Typography color="primary">
                    {t("system.forgotPassword_heading")}
                  </Typography>
                  <div>
                    <Input name="email" type="input" label="E-Mail" />
                  </div>
                  <div>
                    <Button
                      className={styles.button}
                      style={{ marginRight: "10%" }}
                      color="primary"
                      variant="contained"
                      disabled={isSubmitting}
                      type="submit"
                    >
                      {t("system.send_btn")}
                    </Button>
                    <Button
                      className={styles.button}
                      color="primary"
                      variant="outlined"
                      disabled={isSubmitting}
                      onClick={switchToLogin}
                    >
                      {t("system.login_link")}
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          )}

          {passwordForgotFormSubmitted && (
            <div>
              <Typography color="primary">{displayMessage}</Typography>
              <Button
                className={styles.button}
                color="primary"
                variant="contained"
                fullWidth
                onClick={switchToLogin}
              >
                {t("system.login_link")}
              </Button>
            </div>
          )}
        </Grid>
      )}
    </Grid>
  );
};

const getErrorMessage = (msg, t) => {
  if (msg === "errors.wrongcredentials") return t("errors.wrongcredentials");
  else if (msg === "errors.licenseexpired") return t("errors.licenseexpired");
  else if (msg === "errors.blockeduser") return t("errors.blockeduser");
  else if (msg === "errors.unknownerror") return t("errors.unknownerror");
};

const mapStateToProps = ({ user, errors }) => ({
  user,
  errors,
});

const mapDispatchToProps = (dispatch) => ({
  setOriginalPath: (path) => dispatch(setOriginalPath(path)),
  login: (user) => dispatch(login(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
